import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';

import LanguageSwitcher from './LanguageSwitcher';
import BecomeExhibitorButton from '../../components/BecomeExhibitorButton';
import Navigation_ from './Navigation';
import MobileNavigation_ from './MobileNavigation';
import Link from '../../components/Link';
import { breakpoints } from '../../constants';

import background from '../assets/header-background.jpg';
import backgroundMob from '../assets/header-background-mob.jpg';
import logo from '../assets/logo.svg';
import organizedBy from '../assets/organized-by.png';

import Countdown, { zeroPad } from 'react-countdown';

const rubaeDate = new Date('2020-09-09');

const HeaderSection = styled.section`
    background: url(${background}) center center no-repeat no-repeat;
    background-size: cover;
    height: 370px;
    position: relative;

    @media (max-width: ${breakpoints.tablet}) {
        background: url(${backgroundMob}) center center no-repeat no-repeat;
        background-size: cover;
        margin-bottom: 150px;
        height: 350px;
        &:after {
            display: block;
            position: absolute;
            top: 100%;
            content: '';
            background: url(${organizedBy}) center center no-repeat no-repeat;
            background-size: 50%;
            height: 150px;
            width: 100vw;
        }
    }

    @media (max-width: ${breakpoints.mobile}) {
        margin-bottom: 100px;
        height: 350px;
        &:after {
            height: 100px;
            background-size: 60%;
        }
    }
`;

const Logo = styled.a`
    background: url(${logo}) no-repeat;
    background-size: contain;
    display: inline-block;
    width: 250px;
    height: 130px;
    margin-left: 275px;
    margin-top: 35px;

    @media (max-width: ${breakpoints.tablet}) {
        display: none;
    }
`;

const LogoMob = styled.a`
    display: none;
    @media (max-width: ${breakpoints.tablet}) {
        background: url(${logo}) no-repeat;
        background-size: contain;
        display: inline-block;
        width: 80px;
        height: 80px;
        margin-left: 40px;
        margin-top: 30px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        margin-left: 20px;
    }
`;

const Dates = styled.div`
    position: absolute;
    top: 200px;
    left: 370px;
    font-size: 1rem;
    text-align: center;
    color: #003056;
    font-weight: bold;

    @media (max-width: ${breakpoints.tablet}) {
        color: white;
        top: 150px;
        left: 40px;
        font-size: 1.5rem;
    }

    @media (max-width: ${breakpoints.mobile}) {
        font-size: 1.3rem;
        position: initial;
        margin-top: 1rem;
        /* top: 115px;
        left: 20px; */
    }
`;

const Numbers = styled.div`
    color: #20bbef;
    font-size: 2.5rem;
    line-height: 2.5rem;
    font-weight: normal;

    @media (max-width: ${breakpoints.tablet}) {
        color: white;
        font-size: 4rem;
        line-height: 4rem;
    }

    @media (max-width: ${breakpoints.mobile}) {
        font-size: 3rem;
    }
`;

const Place = styled.div`
    font-size: 80%;
`;

const OrganizedBy = styled.img`
    position: absolute;
    top: 330px;
    left: 395px;
    width: 200px;

    @media (max-width: ${breakpoints.tablet}) {
        display: none;
    }
`;

const Slogan = styled.div`
    position: absolute;
    font-size: 1.5rem;
    text-align: right;
    color: white;
    text-transform: uppercase;
    right: 200px;
    top: 100px;

    span {
        display: inline-block;
        border: 1px solid white;
        padding: 4px 5px 0;
        line-height: 100%;
    }

    @media (max-width: ${breakpoints.tablet}) {
        top: 160px;
        right: 40px;
        font-size: 1.2rem;
    }

    @media (max-width: ${breakpoints.mobile}) {
        font-size: 1rem;
        /* top: 130px;
        right: 20px; */
        position: initial;
        text-align: center;
        margin-top: 1rem;
    }
`;

const CountdownSt = styled.div`
    position: absolute;
    font-size: 1.5rem;
    border-radius: 5px;
    width: 380px;
    text-align: center;
    background-color: red;
    /*color: rgb(15, 45, 76);*/
    color: white;
    /* text-transform: uppercase;*/
    right: 200px;
    top: 220px;

    span {
        display: inline-block;
        width: 40px;
        padding: 2px 0 0;
        text-align: center;
    }

    @media (max-width: ${breakpoints.tablet}) {
        top: 235px;
        width: 265px;
        right: 40px;
        font-size: 1.2rem;
        span {
            width: 28px;
        }
    }

    @media (max-width: ${breakpoints.mobile}) {
        font-size: 0.8rem;
        top: 277px;
        width: 180px;
        position: initial;
        margin-left: auto;
        margin-right: auto;

        span {
            width: 18px;
        }
    }
`;

const renderer = ({ days, hours, minutes, seconds }) => {
    return (
        <CountdownSt>
            <FormattedMessage id="header.countDown.cancelText" />
        </CountdownSt>
    );
};
const StyledBecomeExhibitorButton = styled(BecomeExhibitorButton)`
    position: absolute;
    right: 200px;
    top: 300px;
    @media (max-width: ${breakpoints.tablet}) {
        top: 300px;
        right: 40px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        top: 305px;
        right: 20px;
    }
`;

const StyledRegistrationButton = styled(Link)`
    position: absolute;
    right: 200px;
    top: 615px;
`;

const NavigationWrapper = styled.div`
    position: absolute;
    top: 35px;
    right: 200px;
    display: flex;

    @media (max-width: ${breakpoints.tablet}) {
        position: initial;
        display: flex;
        align-items: center;
        width: 100%;
        height: 80px;
        background-color: white;
    }
`;

const LanguageSwitcherWrapper = styled.div`
    position: absolute;
    top: 35px;
    right: 45px;
    border-bottom: 1px solid white;

    a {
        text-decoration: none;
    }

    @media (max-width: ${breakpoints.tablet}) {
        right: 80px;
        top: 30px;
        a {
            color: #003056 !important;
        }
    }
`;

const Navigation = styled(Navigation_)`
    @media (max-width: ${breakpoints.tablet}) {
        display: none;
        margin-left: 30px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        display: none;
    }
`;

const MobileNavigation = styled(MobileNavigation_)`
    display: none;
    margin-left: auto;
    @media (max-width: ${breakpoints.tablet}) {
        display: initial;
    }
`;

const SaleMessage = styled.div`
    text-transform: uppercase;
    position: absolute;
    width: 14rem;
    right: 200px;
    top: 635px;
    color: white;
    font-weight: bold;
    background-color: #003761;
    padding: 0.5rem 1rem;
    box-shadow: 0px 1px 5px #505050;
    @media (max-width: ${breakpoints.tablet}) {
        top: 700px;
        right: 40px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        top: 433px;
        right: 20px;
        font-size: 90%;
        width: 15rem;
    }
`;

const BuyTicketButton = styled(Link)`
    position: absolute;
    right: 200px;
    top: 300px;
    background-color: red;
    font-weight: bold;
    border-color: red;
    color: white;
    @media (max-width: ${breakpoints.tablet}) {
        top: 300px;
        right: 40px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        top: 310px;
        right: 20px;
        font-size: 90%;
    }
`;

class Header extends React.Component {
    render() {
        const { langs, intl } = this.props;

        return (
            <HeaderSection>
                <NavigationWrapper>
                    <LogoMob />
                    <Navigation header />
                    <MobileNavigation />
                </NavigationWrapper>
                <LanguageSwitcherWrapper>
                    <LanguageSwitcher langs={langs} />
                </LanguageSwitcherWrapper>
                <Logo />
                <Dates>
                    <Numbers>8•9•10</Numbers>
                    <div>
                        <FormattedMessage id="header.dates.date" />
                    </div>
                    <Place>
                        <FormattedMessage id="header.dates.place" />
                    </Place>
                </Dates>
                <OrganizedBy src={organizedBy} />

                <Slogan
                    dangerouslySetInnerHTML={{
                        __html: intl.formatHTMLMessage({ id: 'header.slogan' }),
                    }}
                />
                {/*<Countdown date={rubaeDate} renderer={renderer} />*/}
                {/* <SaleMessage>
                    <FormattedMessage id="header.saleMessage" />
                </SaleMessage> */}
                <BuyTicketButton
                    className="button"
                    to={
                        'https://rubae21.ruwidgets.ru/' +
                        (intl.locale === 'ru' ? '' : 'en/')
                    }
                >
                    <FormattedMessage id="exhibitors.attendee.buttonTitle" />
                </BuyTicketButton>
                {/*<StyledBecomeExhibitorButton
                    label={intl.formatMessage({ id: 'header.button' })}
                />*/}
                {/*<StyledRegistrationButton
                    to="pages/registration"
                    className="button"
                >
                    {intl.formatHTMLMessage({
                        id: 'header.registrationButton',
                    })}
                </StyledRegistrationButton> */}
            </HeaderSection>
        );
    }
}

export default injectIntl(Header);



// WEBPACK FOOTER //
// ./src/layouts/components/IndexHeader.js